export default __webpack_public_path__ + "static/media/menuProgramme.a4a21906.jpg";